import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { LanguageProvider } from "./context/LanguageContext";
import MenuPage from "./pages/MenuPage";
import Fichaje from "./pages/Fichaje";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminUsers from "./pages/AdminUsers";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettings from "./pages/AdminSettings";
import AdminTasks from "./pages/AdminTasks";
import AdminTasksReports from "./pages/AdminTasksReports";
import AdminSuppliers from "./pages/AdminSuppliers";
import AdminSupplierDetail from "./pages/AdminSupplierDetail";
import AdminItemSearch from "./pages/AdminItemSearch";
import AdminNotifications from "./pages/AdminNotifications";
import AdminMenu from "./pages/AdminMenu";
import AdminOrders from "./pages/AdminOrders";
import AdminBar from "./pages/AdminBar";
import AdminPrinters from "./pages/AdminPrinters";
import AdminAllergens from "./pages/AdminAllergens";
import AllergensPage from "./pages/AllergensPage";
import AdminInvoiceSearch from "./pages/AdminInvoiceSearch";
import AdminUploadDocuments from "./pages/AdminUploadDocuments";
import PublicOrders from "./pages/PublicOrders";

function ProtectedAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#718096] font-display">
        Cargando…
      </div>
    );
  }
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <CartProvider>
            <BrowserRouter>
              <Toaster richColors position="top-center" />
              <Routes>
                <Route path="/" element={<MenuPage />} />
                <Route path="/carta/alergenos" element={<AllergensPage />} />
                <Route path="/fichaje" element={<Fichaje />} />
                <Route path="/pedidos" element={<PublicOrders />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedAdmin>
                      <AdminLayout />
                    </ProtectedAdmin>
                  }
                >
                  <Route index element={<Navigate to="dashboard" replace />} />
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="users" element={<AdminUsers />} />
                  <Route path="suppliers" element={<AdminSuppliers />} />
                  <Route path="suppliers/:id" element={<AdminSupplierDetail />} />
                  <Route path="invoices" element={<AdminInvoiceSearch />} />
                  <Route path="upload-documents" element={<AdminUploadDocuments />} />
                  <Route path="items" element={<AdminItemSearch />} />
                  <Route path="menu" element={<AdminMenu />} />
                  <Route path="allergens" element={<AdminAllergens />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="bar" element={<AdminBar />} />
                  <Route path="notifications" element={<AdminNotifications />} />
                  <Route path="printers" element={<AdminPrinters />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="tasks" element={<AdminTasks />} />
                  <Route path="tasks-reports" element={<AdminTasksReports />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
